unit UOrders;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.Client, XData.Web.Connection,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Toast, WEBLib.Grids,
  Vcl.Grids, ULogin, WEBLib.Buttons, Vcl.Imaging.pngimage
  {$IFDEF DEBUG}
  ,WEBLib.WebTools
  {$ENDIF}, WEBLib.ExtCtrls, WEBLib.WebCtrls;

type
  TfrmOrders = class(TForm)
    edtEmptyBack: TEdit;
    edtDirty: TEdit;
    edtEmptyNeeded: TEdit;
    lblMain: TLabel;
    lblDirty: TLabel;
    lblEmptyNeeded: TLabel;
    lblEmptyBack: TLabel;
    lblModified: TLabel;
    mmComment: TMemo;
    lblComment: TLabel;
    btnUpdate: TButton;
    edtModified: TEdit;
    toastMessage: TToast;
    divOrdersMainContainer: THTMLDiv;
    divOrdersOuterContainer: THTMLDiv;
    lblDate: TLabel;
    lblStartDriving: TLabel;
    lblDateText: TLabel;
    lblStartDrivingText: TLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    [async]procedure btnUpdateClick(Sender: TObject); async;
    procedure WebFormShow(Sender: TObject);
    procedure toastMessageHide(Sender: TObject; AIndex: Integer);
  private
    { Private declarations }
    FOrderID: Integer;
    FLaundryID: Integer;
    FSearchDate: TDateTime;
    procedure SetOrderID(const Value: Integer);
    [async]procedure UpdateLaundry(AId: integer; ALaundry: JS.TJSObject); async;
    [async]procedure LogLaundry(ALaundry: JS.TJSObject); async;
    procedure ContainerUpdateComplete;
    procedure SetLaundryID(const Value: Integer);
    procedure LogLaundryJSON;
    procedure LaundryUpdateJSON;
    procedure SetSearchDate(const Value: TDateTime);
  public
    { Public declarations }
    property OrderID: Integer read FOrderID write SetOrderID;
    property LaundryID: Integer read FLaundryID write SetLaundryID;
    property SearchDate: TDateTime read FSearchDate write SetSearchDate;
  protected procedure LoadDFMValues; override; end;

var
  frmOrders: TfrmOrders;

implementation

{$R *.dfm}

uses
   UDatamodule, UOrdersMain, UHelper, UJSHelper, UResources, UErrorHandling,
   USmptJSWrapper;

// JSON String
//    '{ '+
//      '"Dirty": 0,'+
//      '"EmptyNeeded": 0,'+
//      '"EmptyBack": 0',+
//      '"Comment": "string",'+
//      '"Modified": "dateS"+
//     '}');


procedure TfrmOrders.btnUpdateClick(Sender: TObject);
begin
  LaundryUpdateJSON;
  {$IFDEF PAS2JS}
  asm
    if (Notification.permission !== "denied" && Notification.permission !== "granted") {
      // We need to ask the user for permission
      Notification.requestPermission().then((permission) => {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
          const msg = firebase.messaging();
          msg.getToken(msg, {vapidKey: "BDcFkcmFcaHYHkf6kpwLbXM-yN-8cNE_FId5JHzfW1jQxnRDNNHYw2we5UJCQiPVP_QBPRYuNufQTPbNCwoFR7Q"}).then((currentToken) => {
          if (currentToken) {
            pas.UMainMenu.TfrmMainMenu.SetMsgToken(currentToken);
          }
        }).catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
        });
        }
      });
    }
  end;
  {$ENDIF}
end;


procedure TfrmOrders.SetLaundryID(const Value: Integer);
begin
  FLaundryID := Value;
end;

procedure TfrmOrders.LogLaundryJSON;
var
  lLaundryLog: JS.TJSObject;
begin
  lLaundryLog := TJSJson.parseObject(
    '{ ' +
    '"userID": ' + UDM.UserId.ToString + ',' +
    '"dirty": ' + edtDirty.Text + ',' +
    '"empty_needed": ' + edtEmptyNeeded.Text + ',' +
    '"empty_back": ' + edtEmptyBack.Text + ' ,' +
    '"comment": ' + TJSJson.stringify(mmComment.Text) + ',' +
    '"laundryID": ' + LaundryID.ToString +
    ' }');

  LogLaundry(lLaundryLog);
end;


procedure TfrmOrders.LaundryUpdateJSON;
var
  lLaundry: JS.TJSObject;
begin
  lLaundry := TJSJson.parseObject(
    '{' +
    '"Comment": ' + TJSJson.stringify(mmComment.Text) + ' ,' +
    '"Dirty": ' + edtDirty.Text + ',      ' +
    '"EmptyNeeded": ' + edtEmptyNeeded.Text + ',' +
    '"EmptyBack": ' + edtEmptyBack.Text + ',' +
    '"ModifiedBy": ' + UDM.UserID.ToString + ',' +
    '"UserID": ' + UDM.UserID.ToString + ',' +
    '"KundenID": ' + UDM.CustomerID.ToString +
    ' }');

  UpdateLaundry(OrderId, lLaundry);
end;

procedure TfrmOrders.SetOrderID(const Value: Integer);
begin
  FOrderID := Value;
end;

procedure TfrmOrders.SetSearchDate(const Value: TDateTime);
begin
  FSearchDate := Value;
end;

procedure TfrmOrders.UpdateLaundry(AId: integer; ALaundry: JS.TJSObject);
var
  LResponse: TXDataClientResponse;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('ILaundry.UpdateLaundry',
        [AId, JSValue(ALaundry)])
      );
    console.log(LResponse.StatusCode);
    if LResponse.StatusCode = 200 then
    begin
      LogLaundryJSON;
      ContainerUpdateComplete;
    end
    else
    begin
      MessageDlg('Error occured, please try again.', mtError, [mbAbort]);
    end;

    except
      on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;

end;

procedure TfrmOrders.ContainerUpdateComplete;
var
  llang: string;
  lform: TfrmOrdersMain;
begin
  if window.outerWidth > 575 then
  begin
    toastMessage.X := (window.outerWidth div 2) - 200;
  end
  else
  begin
    toastMessage.X := 12;
  end;
  toastMessage.Y := 0;
  //window.outerHeight div 2;

  llang := window.localStorage.getItem('language');
  if llang <> '' then
  begin
    if llang = 'en' then
    begin
      console.log('en');
      toastMessage.Items.Items[1].Show;
    end
    else if llang = 'de' then
    begin
      console.log('de');
      toastMessage.Items.Items[0].Show;
    end;
  end;
  UDM.Form := sPageOrders;
  if Assigned(lform) then
  begin
    lform.Close;
  end;
  lform := TfrmOrdersMain.CreateNew(divOrdersOuterContainer.ElementID, nil);
end;

procedure TfrmOrders.LogLaundry(ALaundry: JS.TJSObject);
var
  LResponse: TXDataClientResponse;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('ILaundry.InsertLog',
        [JSValue(ALaundry)])
      );
    if LResponse.StatusCode = 200 then
    begin

    end
    else
    begin
      MessageDlg('Error occured, please try again.', mtError, [mbAbort]);
    end;

    except
      on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;

end;


procedure TfrmOrders.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Action := caFree;
end;


procedure TfrmOrders.WebFormCreate(Sender: TObject);
begin
  mmComment.Clear;
end;


procedure TfrmOrders.WebFormShow(Sender: TObject);
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.OrderInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
  end;
  {$ENDIF}
end;

procedure TfrmOrders.toastMessageHide(Sender: TObject; AIndex: Integer);
begin

end;

procedure TfrmOrders.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divOrdersOuterContainer := THTMLDiv.Create('wcIDOrdersMainContent');
  divOrdersMainContainer := THTMLDiv.Create('wcIDMainContainer');
  lblComment := TLabel.Create('wcIDComment');
  lblDirty := TLabel.Create('wcIDDirty');
  lblEmptyBack := TLabel.Create('wcIDEmptyContainersBack');
  lblEmptyNeeded := TLabel.Create('wcIDEmptyContainersNeeded');
  lblMain := TLabel.Create('wcIDHeading');
  lblModified := TLabel.Create('wcIDModified');
  lblDate := TLabel.Create('wcIDDate');
  lblStartDriving := TLabel.Create('wcIDTime');
  lblDateText := TLabel.Create('wcIDDateInput');
  lblStartDrivingText := TLabel.Create('wcIDTimeInput');
  btnUpdate := TButton.Create('wcIDUpdateBtn');
  edtDirty := TEdit.Create('wcIDDirtyInput');
  edtEmptyBack := TEdit.Create('wcIDEmptyContainersBackInput');
  edtEmptyNeeded := TEdit.Create('wcIDEmptyContainersNeededInput');
  edtModified := TEdit.Create('wcIDModifiedInput');
  mmComment := TMemo.Create('wcIDCommentInput');
  toastMessage := TToast.Create(Self);

  divOrdersOuterContainer.BeforeLoadDFMValues;
  divOrdersMainContainer.BeforeLoadDFMValues;
  lblComment.BeforeLoadDFMValues;
  lblDirty.BeforeLoadDFMValues;
  lblEmptyBack.BeforeLoadDFMValues;
  lblEmptyNeeded.BeforeLoadDFMValues;
  lblMain.BeforeLoadDFMValues;
  lblModified.BeforeLoadDFMValues;
  lblDate.BeforeLoadDFMValues;
  lblStartDriving.BeforeLoadDFMValues;
  lblDateText.BeforeLoadDFMValues;
  lblStartDrivingText.BeforeLoadDFMValues;
  btnUpdate.BeforeLoadDFMValues;
  edtDirty.BeforeLoadDFMValues;
  edtEmptyBack.BeforeLoadDFMValues;
  edtEmptyNeeded.BeforeLoadDFMValues;
  edtModified.BeforeLoadDFMValues;
  mmComment.BeforeLoadDFMValues;
  toastMessage.BeforeLoadDFMValues;
  try
    Name := 'frmOrders';
    Width := 916;
    Height := 794;
    Color := clCream;
    CSSLibrary := cssBootstrap;
    ElementClassName := 'panels-light-yellow';
    ElementFont := efCSS;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divOrdersOuterContainer.SetParentComponent(Self);
    divOrdersOuterContainer.Name := 'divOrdersOuterContainer';
    divOrdersOuterContainer.Left := 0;
    divOrdersOuterContainer.Top := 0;
    divOrdersOuterContainer.Width := 916;
    divOrdersOuterContainer.Height := 794;
    divOrdersOuterContainer.HeightStyle := ssAuto;
    divOrdersOuterContainer.WidthStyle := ssAuto;
    divOrdersOuterContainer.Align := alClient;
    divOrdersOuterContainer.ChildOrder := 1;
    divOrdersOuterContainer.ElementPosition := epIgnore;
    divOrdersOuterContainer.ElementFont := efCSS;
    divOrdersOuterContainer.Role := '';
    divOrdersMainContainer.SetParentComponent(divOrdersOuterContainer);
    divOrdersMainContainer.Name := 'divOrdersMainContainer';
    divOrdersMainContainer.Left := 0;
    divOrdersMainContainer.Top := 0;
    divOrdersMainContainer.Width := 916;
    divOrdersMainContainer.Height := 794;
    divOrdersMainContainer.Align := alClient;
    divOrdersMainContainer.ChildOrder := 31;
    divOrdersMainContainer.ElementFont := efCSS;
    divOrdersMainContainer.Role := '';
    lblComment.SetParentComponent(divOrdersMainContainer);
    lblComment.Name := 'lblComment';
    lblComment.Left := 67;
    lblComment.Top := 439;
    lblComment.Width := 147;
    lblComment.Height := 35;
    lblComment.Caption := 'Kommentar';
    lblComment.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLContainerLbl';
    lblComment.ElementPosition := epIgnore;
    lblComment.Font.Charset := DEFAULT_CHARSET;
    lblComment.Font.Color := clWindowText;
    lblComment.Font.Height := -29;
    lblComment.Font.Name := 'Tahoma';
    lblComment.Font.Style := [];
    lblComment.HeightStyle := ssAuto;
    lblComment.HeightPercent := 100.000000000000000000;
    lblComment.ParentFont := False;
    lblComment.WidthStyle := ssAuto;
    lblComment.WidthPercent := 100.000000000000000000;
    lblDirty.SetParentComponent(divOrdersMainContainer);
    lblDirty.Name := 'lblDirty';
    lblDirty.Left := 67;
    lblDirty.Top := 320;
    lblDirty.Width := 320;
    lblDirty.Height := 35;
    lblDirty.Caption := 'Schmutzw'#228'schecontainer';
    lblDirty.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLContainerLbl';
    lblDirty.ElementPosition := epIgnore;
    lblDirty.Font.Charset := DEFAULT_CHARSET;
    lblDirty.Font.Color := clWindowText;
    lblDirty.Font.Height := -29;
    lblDirty.Font.Name := 'Tahoma';
    lblDirty.Font.Style := [];
    lblDirty.HeightStyle := ssAuto;
    lblDirty.HeightPercent := 100.000000000000000000;
    lblDirty.ParentFont := False;
    lblDirty.WidthStyle := ssAuto;
    lblDirty.WidthPercent := 100.000000000000000000;
    lblEmptyBack.SetParentComponent(divOrdersMainContainer);
    lblEmptyBack.Name := 'lblEmptyBack';
    lblEmptyBack.Left := 67;
    lblEmptyBack.Top := 259;
    lblEmptyBack.Width := 450;
    lblEmptyBack.Height := 35;
    lblEmptyBack.Caption := 'Leercontainer vom Kunden abholen';
    lblEmptyBack.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLContainerLbl';
    lblEmptyBack.ElementPosition := epIgnore;
    lblEmptyBack.Font.Charset := DEFAULT_CHARSET;
    lblEmptyBack.Font.Color := clWindowText;
    lblEmptyBack.Font.Height := -29;
    lblEmptyBack.Font.Name := 'Tahoma';
    lblEmptyBack.Font.Style := [];
    lblEmptyBack.HeightStyle := ssAuto;
    lblEmptyBack.HeightPercent := 100.000000000000000000;
    lblEmptyBack.ParentFont := False;
    lblEmptyBack.WidthStyle := ssAuto;
    lblEmptyBack.WidthPercent := 100.000000000000000000;
    lblEmptyNeeded.SetParentComponent(divOrdersMainContainer);
    lblEmptyNeeded.Name := 'lblEmptyNeeded';
    lblEmptyNeeded.Left := 67;
    lblEmptyNeeded.Top := 200;
    lblEmptyNeeded.Width := 427;
    lblEmptyNeeded.Height := 35;
    lblEmptyNeeded.Caption := 'Leercontainer zum Kunden liefern';
    lblEmptyNeeded.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLContainerLbl';
    lblEmptyNeeded.ElementPosition := epIgnore;
    lblEmptyNeeded.Font.Charset := DEFAULT_CHARSET;
    lblEmptyNeeded.Font.Color := clWindowText;
    lblEmptyNeeded.Font.Height := -29;
    lblEmptyNeeded.Font.Name := 'Tahoma';
    lblEmptyNeeded.Font.Style := [];
    lblEmptyNeeded.HeightStyle := ssAuto;
    lblEmptyNeeded.HeightPercent := 100.000000000000000000;
    lblEmptyNeeded.ParentFont := False;
    lblEmptyNeeded.WidthStyle := ssAuto;
    lblEmptyNeeded.WidthPercent := 100.000000000000000000;
    lblMain.SetParentComponent(divOrdersMainContainer);
    lblMain.Name := 'lblMain';
    lblMain.Left := 253;
    lblMain.Top := 23;
    lblMain.Width := 676;
    lblMain.Height := 58;
    lblMain.AutoSize := False;
    lblMain.Caption := 'Container Infos';
    lblMain.ElementClassName := 'control-label col-xl-9 col-lg-9 col-md-7 display-5 mb-5 wcCLLaundryLbl';
    lblMain.ElementPosition := epIgnore;
    lblMain.Font.Charset := DEFAULT_CHARSET;
    lblMain.Font.Color := clWindowText;
    lblMain.Font.Height := -48;
    lblMain.Font.Name := 'Tahoma';
    lblMain.Font.Style := [];
    lblMain.HeightStyle := ssAuto;
    lblMain.HeightPercent := 100.000000000000000000;
    lblMain.ParentFont := False;
    lblMain.WidthStyle := ssAuto;
    lblMain.WidthPercent := 100.000000000000000000;
    lblModified.SetParentComponent(divOrdersMainContainer);
    lblModified.Name := 'lblModified';
    lblModified.Left := 67;
    lblModified.Top := 377;
    lblModified.Width := 164;
    lblModified.Height := 35;
    lblModified.Caption := 'Ge'#228'ndert am';
    lblModified.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLContainerLbl';
    lblModified.ElementPosition := epIgnore;
    lblModified.Font.Charset := DEFAULT_CHARSET;
    lblModified.Font.Color := clWindowText;
    lblModified.Font.Height := -29;
    lblModified.Font.Name := 'Tahoma';
    lblModified.Font.Style := [];
    lblModified.HeightStyle := ssAuto;
    lblModified.HeightPercent := 100.000000000000000000;
    lblModified.ParentFont := False;
    lblModified.WidthStyle := ssAuto;
    lblModified.WidthPercent := 100.000000000000000000;
    lblDate.SetParentComponent(divOrdersMainContainer);
    lblDate.Name := 'lblDate';
    lblDate.Left := 88;
    lblDate.Top := 120;
    lblDate.Width := 210;
    lblDate.Height := 29;
    lblDate.Caption := 'Lieferdatum Fliegel:';
    lblDate.ElementClassName := 'control-label col-xl-6 col-lg-6 col-md-7 col-sm-8 h6 wcCLContainerLbl';
    lblDate.ElementFont := efCSS;
    lblDate.Font.Charset := DEFAULT_CHARSET;
    lblDate.Font.Color := clWindowText;
    lblDate.Font.Height := -24;
    lblDate.Font.Name := 'Tahoma';
    lblDate.Font.Style := [];
    lblDate.HeightStyle := ssAuto;
    lblDate.HeightPercent := 100.000000000000000000;
    lblDate.ParentFont := False;
    lblDate.WidthPercent := 100.000000000000000000;
    lblStartDriving.SetParentComponent(divOrdersMainContainer);
    lblStartDriving.Name := 'lblStartDriving';
    lblStartDriving.Left := 488;
    lblStartDriving.Top := 120;
    lblStartDriving.Width := 180;
    lblStartDriving.Height := 29;
    lblStartDriving.Caption := 'Lieferzeit Fliegel:';
    lblStartDriving.ElementClassName := 'control-label col-xl-6 col-lg-6 col-md-7 col-sm-8 h6 wcCLContainerLbl';
    lblStartDriving.ElementFont := efCSS;
    lblStartDriving.Font.Charset := DEFAULT_CHARSET;
    lblStartDriving.Font.Color := clWindowText;
    lblStartDriving.Font.Height := -24;
    lblStartDriving.Font.Name := 'Tahoma';
    lblStartDriving.Font.Style := [];
    lblStartDriving.HeightStyle := ssAuto;
    lblStartDriving.HeightPercent := 100.000000000000000000;
    lblStartDriving.ParentFont := False;
    lblStartDriving.WidthPercent := 100.000000000000000000;
    lblDateText.SetParentComponent(divOrdersMainContainer);
    lblDateText.Name := 'lblDateText';
    lblDateText.Left := 311;
    lblDateText.Top := 123;
    lblDateText.Width := 105;
    lblDateText.Height := 25;
    lblDateText.Caption := 'lblDateText';
    lblDateText.ElementClassName := 'wcCLContainerLbl wcCLOrdersInfo';
    lblDateText.ElementFont := efCSS;
    lblDateText.Font.Charset := DEFAULT_CHARSET;
    lblDateText.Font.Color := clWindowText;
    lblDateText.Font.Height := -21;
    lblDateText.Font.Name := 'Tahoma';
    lblDateText.Font.Style := [];
    lblDateText.HeightStyle := ssAuto;
    lblDateText.HeightPercent := 100.000000000000000000;
    lblDateText.ParentFont := False;
    lblDateText.WidthPercent := 100.000000000000000000;
    lblStartDrivingText.SetParentComponent(divOrdersMainContainer);
    lblStartDrivingText.Name := 'lblStartDrivingText';
    lblStartDrivingText.Left := 688;
    lblStartDrivingText.Top := 123;
    lblStartDrivingText.Width := 173;
    lblStartDrivingText.Height := 25;
    lblStartDrivingText.Caption := 'lblStartDrivingText';
    lblStartDrivingText.ElementClassName := 'wcCLContainerLbl wcCLOrdersInfo';
    lblStartDrivingText.ElementFont := efCSS;
    lblStartDrivingText.Font.Charset := DEFAULT_CHARSET;
    lblStartDrivingText.Font.Color := clWindowText;
    lblStartDrivingText.Font.Height := -21;
    lblStartDrivingText.Font.Name := 'Tahoma';
    lblStartDrivingText.Font.Style := [];
    lblStartDrivingText.HeightStyle := ssAuto;
    lblStartDrivingText.HeightPercent := 100.000000000000000000;
    lblStartDrivingText.ParentFont := False;
    lblStartDrivingText.WidthPercent := 100.000000000000000000;
    btnUpdate.SetParentComponent(divOrdersMainContainer);
    btnUpdate.Name := 'btnUpdate';
    btnUpdate.Left := 393;
    btnUpdate.Top := 681;
    btnUpdate.Width := 145;
    btnUpdate.Height := 50;
    btnUpdate.Caption := #220'bermitteln';
    btnUpdate.ChildOrder := 25;
    btnUpdate.ElementClassName := 'btn btn-primary wcCLUpdateBtn';
    btnUpdate.ElementPosition := epIgnore;
    btnUpdate.Font.Charset := DEFAULT_CHARSET;
    btnUpdate.Font.Color := clWindowText;
    btnUpdate.Font.Height := -19;
    btnUpdate.Font.Name := 'Tahoma';
    btnUpdate.Font.Style := [];
    btnUpdate.HeightStyle := ssAuto;
    btnUpdate.HeightPercent := 100.000000000000000000;
    btnUpdate.ParentFont := False;
    btnUpdate.TabOrder := 9;
    btnUpdate.WidthStyle := ssAuto;
    btnUpdate.WidthPercent := 100.000000000000000000;
    SetEvent(btnUpdate, Self, 'OnClick', 'btnUpdateClick');
    edtDirty.SetParentComponent(divOrdersMainContainer);
    edtDirty.Name := 'edtDirty';
    edtDirty.Left := 526;
    edtDirty.Top := 319;
    edtDirty.Width := 322;
    edtDirty.Height := 35;
    edtDirty.ChildOrder := 3;
    edtDirty.ElementClassName := 'form-control';
    edtDirty.ElementPosition := epIgnore;
    edtDirty.Font.Charset := DEFAULT_CHARSET;
    edtDirty.Font.Color := clWindowText;
    edtDirty.Font.Height := -27;
    edtDirty.Font.Name := 'Tahoma';
    edtDirty.Font.Style := [];
    edtDirty.HeightStyle := ssAuto;
    edtDirty.HeightPercent := 100.000000000000000000;
    edtDirty.ParentFont := False;
    edtDirty.TabOrder := 3;
    edtDirty.WidthStyle := ssAuto;
    edtDirty.WidthPercent := 100.000000000000000000;
    edtEmptyBack.SetParentComponent(divOrdersMainContainer);
    edtEmptyBack.Name := 'edtEmptyBack';
    edtEmptyBack.Left := 526;
    edtEmptyBack.Top := 258;
    edtEmptyBack.Width := 322;
    edtEmptyBack.Height := 35;
    edtEmptyBack.ChildOrder := 3;
    edtEmptyBack.ElementClassName := 'form-control';
    edtEmptyBack.ElementPosition := epIgnore;
    edtEmptyBack.Font.Charset := DEFAULT_CHARSET;
    edtEmptyBack.Font.Color := clWindowText;
    edtEmptyBack.Font.Height := -27;
    edtEmptyBack.Font.Name := 'Tahoma';
    edtEmptyBack.Font.Style := [];
    edtEmptyBack.HeightStyle := ssAuto;
    edtEmptyBack.HeightPercent := 100.000000000000000000;
    edtEmptyBack.ParentFont := False;
    edtEmptyBack.TabOrder := 5;
    edtEmptyBack.WidthStyle := ssAuto;
    edtEmptyBack.WidthPercent := 100.000000000000000000;
    edtEmptyNeeded.SetParentComponent(divOrdersMainContainer);
    edtEmptyNeeded.Name := 'edtEmptyNeeded';
    edtEmptyNeeded.Left := 526;
    edtEmptyNeeded.Top := 199;
    edtEmptyNeeded.Width := 322;
    edtEmptyNeeded.Height := 35;
    edtEmptyNeeded.ChildOrder := 3;
    edtEmptyNeeded.ElementClassName := 'form-control';
    edtEmptyNeeded.ElementPosition := epIgnore;
    edtEmptyNeeded.Font.Charset := DEFAULT_CHARSET;
    edtEmptyNeeded.Font.Color := clWindowText;
    edtEmptyNeeded.Font.Height := -27;
    edtEmptyNeeded.Font.Name := 'Tahoma';
    edtEmptyNeeded.Font.Style := [];
    edtEmptyNeeded.HeightStyle := ssAuto;
    edtEmptyNeeded.HeightPercent := 100.000000000000000000;
    edtEmptyNeeded.ParentFont := False;
    edtEmptyNeeded.TabOrder := 4;
    edtEmptyNeeded.WidthStyle := ssAuto;
    edtEmptyNeeded.WidthPercent := 100.000000000000000000;
    edtModified.SetParentComponent(divOrdersMainContainer);
    edtModified.Name := 'edtModified';
    edtModified.Left := 526;
    edtModified.Top := 376;
    edtModified.Width := 322;
    edtModified.Height := 35;
    edtModified.ChildOrder := 3;
    edtModified.ElementClassName := 'form-control';
    edtModified.ElementPosition := epIgnore;
    edtModified.Enabled := False;
    edtModified.Font.Charset := DEFAULT_CHARSET;
    edtModified.Font.Color := clWindowText;
    edtModified.Font.Height := -27;
    edtModified.Font.Name := 'Tahoma';
    edtModified.Font.Style := [];
    edtModified.HeightStyle := ssAuto;
    edtModified.HeightPercent := 100.000000000000000000;
    edtModified.ParentFont := False;
    edtModified.ReadOnly := True;
    edtModified.TabOrder := 7;
    edtModified.WidthStyle := ssAuto;
    edtModified.WidthPercent := 100.000000000000000000;
    mmComment.SetParentComponent(divOrdersMainContainer);
    mmComment.Name := 'mmComment';
    mmComment.Left := 526;
    mmComment.Top := 438;
    mmComment.Width := 322;
    mmComment.Height := 172;
    mmComment.ElementClassName := 'form-control wcCLCommentInput';
    mmComment.ElementPosition := epIgnore;
    mmComment.Font.Charset := DEFAULT_CHARSET;
    mmComment.Font.Color := clWindowText;
    mmComment.Font.Height := -27;
    mmComment.Font.Name := 'Tahoma';
    mmComment.Font.Style := [];
    mmComment.HeightStyle := ssAuto;
    mmComment.HeightPercent := 100.000000000000000000;
    mmComment.Lines.BeginUpdate;
    try
      mmComment.Lines.Clear;
      mmComment.Lines.Add('mmComment');
    finally
      mmComment.Lines.EndUpdate;
    end;
    mmComment.ParentFont := False;
    mmComment.ScrollBars := ssVertical;
    mmComment.SelLength := 0;
    mmComment.SelStart := 0;
    mmComment.TabOrder := 6;
    mmComment.WidthStyle := ssAuto;
    mmComment.WidthPercent := 100.000000000000000000;
    toastMessage.SetParentComponent(Self);
    toastMessage.Name := 'toastMessage';
    toastMessage.AutoHideDelay := 2000;
    toastMessage.Items.Clear;
    with toastMessage.Items.Add do
    begin
      AutoHide := True;
      Body := '<font color="gray" style="font-size: 8pt">&#x25FC;</font><b style="font-size: 78t">Danke, Ihre Daten wurden '#252'bermittelt</b>';
      Time := ttNone;
      Header := '<b style="font-size: 12pt">Information</b>';
    end;
    with toastMessage.Items.Add do
    begin
      AutoHide := True;
      Body := '<font color="gray" style="font-size: 8pt">&#x25FC;</font><b style="font-size: 78t">Thank you, your data has been updated</b>';
      Time := ttNone;
      Header := '<b style="font-size: 12pt">Information</b>';
    end;
    toastMessage.Position := tpAbsolute;
    toastMessage.Left := 824;
    toastMessage.Top := 40;
  finally
    divOrdersOuterContainer.AfterLoadDFMValues;
    divOrdersMainContainer.AfterLoadDFMValues;
    lblComment.AfterLoadDFMValues;
    lblDirty.AfterLoadDFMValues;
    lblEmptyBack.AfterLoadDFMValues;
    lblEmptyNeeded.AfterLoadDFMValues;
    lblMain.AfterLoadDFMValues;
    lblModified.AfterLoadDFMValues;
    lblDate.AfterLoadDFMValues;
    lblStartDriving.AfterLoadDFMValues;
    lblDateText.AfterLoadDFMValues;
    lblStartDrivingText.AfterLoadDFMValues;
    btnUpdate.AfterLoadDFMValues;
    edtDirty.AfterLoadDFMValues;
    edtEmptyBack.AfterLoadDFMValues;
    edtEmptyNeeded.AfterLoadDFMValues;
    edtModified.AfterLoadDFMValues;
    mmComment.AfterLoadDFMValues;
    toastMessage.AfterLoadDFMValues;
  end;
end;

initialization
  RegisterClass(TfrmOrders);

end.